/**
 * Who gets the onboarding welcome flow — the rule alone, importing nothing.
 *
 * Split out of useOnboardingGate so it can be tested. Everything in this repo's
 * vitest setup runs in a node environment, and useOnboardingGate reaches
 * useAccessControl, which transitively pulls in modules that touch `window` at
 * import time (DiagnosticEventLog registers a beforeunload listener in its
 * constructor). A rule this load-bearing shouldn't be untestable because of
 * what its neighbours import.
 *
 * Typed structurally rather than against AccessControl so this file stays free
 * of imports; AccessControl satisfies it.
 */
export type OnboardingEligibilityInput = {
  isInternalUser: boolean;
  subscriptionQuery: { data?: { status?: string } | undefined };
};

/**
 * v1: external trialists only. Isolated so widening the audience later (all
 * new subscribers, demo users…) is a one-line change.
 *
 * If you do widen it, note that the logged-out guided demo keys off
 * `!authenticated` — see demo-guide/__tests__/gateExclusivity.test.ts, which
 * exists to fail loudly if the two audiences are ever made to overlap.
 */
export function isOnboardingEligible(
  access: OnboardingEligibilityInput
): boolean {
  if (access.isInternalUser) return false;
  return access.subscriptionQuery.data?.status === "in_trial";
}
